import { render, staticRenderFns } from "./ItemTemplateAutocomplete.vue?vue&type=template&id=63f0fd40&"
import script from "./ItemTemplateAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ItemTemplateAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./ItemTemplateAutocomplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports